import { render, staticRenderFns } from "./CrudAgency-comp.vue?vue&type=template&id=59d0bb2c&scoped=true&"
import script from "./CrudAgency-comp.vue?vue&type=script&lang=js&"
export * from "./CrudAgency-comp.vue?vue&type=script&lang=js&"
import style0 from "./CrudAgency-comp.vue?vue&type=style&index=0&id=59d0bb2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d0bb2c",
  null
  
)

export default component.exports